const Sunrise = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 108 108"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54 4V44M18.65 48.65L25.7 55.7M4 84H14M94 84H104M89.35 48.65L82.3 55.7M104 104H4M34 24L54 4L74 24M74 84C74 78.6957 71.8929 73.6086 68.1421 69.8579C64.3914 66.1071 59.3043 64 54 64C48.6957 64 43.6086 66.1071 39.8579 69.8579C36.1071 73.6086 34 78.6957 34 84"
      stroke="currentColor"
      strokeWidth="7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Sunrise
